import { CaseReducer, createSlice, PayloadAction } from "@reduxjs/toolkit";

/**
 * Звуки звонков в диспетчерской (глобальные настройки, ui.sounds).
 * В сохранённых настройках блока может не быть — тогда значения по умолчанию,
 * громкость во время разговора 10% соответствует прежнему поведению.
 */

export interface SoundRef {
	fileId: number;
	name: string;
}

export interface SoundSettingValue {
	/** Проценты, 0–100. */
	volume: number;
	/** null — встроенный звук. */
	sound: SoundRef | null;
}

export interface SoundsState {
	incomingCall: SoundSettingValue;
	incomingCallDuringConversation: SoundSettingValue;
}

export const DEFAULT_ONLINE_ORDER_VOLUME = 100;

const initialState: SoundsState = {
	incomingCall: { volume: 100, sound: null },
	incomingCallDuringConversation: { volume: 10, sound: null },
};

export function normalizeSounds(
	raw?: Partial<SoundsState> | null,
): SoundsState {
	return {
		incomingCall: { ...initialState.incomingCall, ...raw?.incomingCall },
		incomingCallDuringConversation: {
			...initialState.incomingCallDuringConversation,
			...raw?.incomingCallDuringConversation,
		},
	};
}

type Reducer<P> = CaseReducer<SoundsState, PayloadAction<P>>;

const setAll: Reducer<Partial<SoundsState> | null | undefined> = (
	_,
	{ payload },
) => normalizeSounds(payload);

const sounds = createSlice({
	name: "sounds",
	initialState,
	reducers: {
		setAll,
	},
});

export default sounds;
